import { FC, useMemo } from "react";
import { handlePortfolioRedirection } from "./portfolioRedirection";
import { CmpDataPortfolioProps, ReportItem } from "./PortfolioTypes";

interface ReportProps {
  cmpData: CmpDataPortfolioProps;
}

const Report: FC<ReportProps> = ({ cmpData }) => {
  const reportItems = cmpData?.reportItems;

  // Get the limit for reports, default to 5 if not specified
  const reportsLimit = useMemo(() => {
    if (cmpData?.reportsLength) {
      const limit = Number(cmpData.reportsLength);
      return Number.isNaN(limit) ? 5 : limit;
    }
    return 5;
  }, [cmpData?.reportsLength]);

  // Convert reportItems object to array of [key, value] pairs and apply limit
  const items = useMemo(() => {
    if (!reportItems || Object.keys(reportItems).length === 0) {
      return [];
    }
    const allItems = Object.entries(reportItems);
    return allItems.slice(0, reportsLimit);
  }, [reportItems, reportsLimit]);

  if (items.length === 0) {
    return (
      <div className="flex min-h-[160px] items-center justify-center rounded-lg border border-dashed border-[#E5E5E5] bg-[#F9FAFB] text-sm text-gray-600">
        No reports available.
      </div>
    );
  }

  const defaultImageUrl =
    "https://publish1apsouth1-28421836.uat.bajajfinance.adobecqms.net/content/dam/investments/portfolio-icons/portfolio-reports-icon1.png";

  return (
    <>
      <div className="flex flex-col max-w-[343px] min-h-[39px] gap-1">
        <div className="text-[18px] font-medium pt-[12px] text-[#1A1A1A]">Track your transactions and stock performance report here</div>
        <div className="text-[12px] font-[400px] text-[#666666]">Reports contains your reports</div>
      </div>
      <div>
      </div>
      <div className="flex flex-col  min-h-[39px] ">
        <div className=" reports-container flex max-w-[700px] flex-col gap-3 py-3">
          {items.map(([key, reportItem]: [string, ReportItem]) => (
            <button
              type="button"
              key={key}
              className="flex w-full cursor-pointer items-center justify-between py-3 text-left"
              onClick={() => {
                handlePortfolioRedirection(
                  reportItem?.redirectUrl ?? "",
                  reportItem?.openInNewTab ?? "false",
                  reportItem?.reportsItemTitleText ?? "Report",
                  reportItem?.screen ?? "",
                  reportItem?.type ?? "",
                  cmpData?.headerName ?? "Bajaj Broking",
                );
              }}
            >
              {/* Left Content */}
              <div className="flex max-w-[600px] items-center gap-2">
                <img
                  className="h-10 w-10"
                  alt={reportItem?.reportsItemTitleText ?? "Reports Icon"}
                  src={reportItem?.image ?? defaultImageUrl}
                />
                <div className="flex min-w-[164px] flex-col gap-1">
                  <div className="text-base font-medium text-[#1A1A1A]">
                    {reportItem?.title ?? "Financial ledger"}
                  </div>
                  <div className="text-xs font-normal text-gray-600">
                    {reportItem?.description ?? "All your charges in one place"}
                  </div>
                </div>
              </div>

              {/* Right Arrow */}
              <div>
                <i className="icomoon inline-block h-6 w-6 text-base before:content-['\e911']" />
              </div>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default Report;
